
export default function TeamSection() {
  const teamMembers = [
    {
      name: "三村 昌裕",
      nameEn: "Masahiro Mimura",
      position: "代表取締役CEO",
      description: "独立系コンサルタントとしてテクノロジーを梃子とした新規事業創造に20年以上の経験を持つ。大企業を中心とした企業支援の他、J-startup企業の創業経営やスタートアップの経営陣として東証マザーズ上場を果たす。社会課題解決への動機とディープテックの社会実装への造詣を背景として、数年の準備期間を経て2025年3月に面氏と共にソーシャルパスを設立。東京工業大学大学院修了。AFJ日本農業経営大学校主任教授。",
      image: "https://static.readdy.ai/image/5743fa161097a13fb02471cc7f354468/d3e58ff92128484da7a2a8e2c0d91f28.jpeg"
    },
    {
      name: "面 和成",
      nameEn: "Kazumasa Omote",
      position: "取締役CTO",
      description: "筑波大学システム情報系教授。内閣府科学技術・イノベーション推進事務局の上席科学技術政策フェローを経て一般社団法人日本暗号資産等取引業協会理事。ブロックチェーンのセキュリティを中心に研究を展開。著書に「入門 サイバーセキュリティ 理論と実験/暗号技術・ネットワークセキュリティ・ブロックチェーンからPython実験まで」などがある。数年の準備期間を経て三村氏と共にソーシャルパスを設立。",
      image: "https://static.readdy.ai/image/5743fa161097a13fb02471cc7f354468/4041235e0a03d64883d913e36d36292c.jpeg"
    }
  ];

  return (
    <section id="team" className="py-16 sm:py-20 bg-white scroll-mt-16 sm:scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-4">
            コアメンバー
          </h2>
          <p className="text-base sm:text-xl text-gray-600 max-w-3xl mx-auto px-4 text-center">
            「自ら選択する未来を」皆さんと共に
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 max-w-4xl mx-auto">
          {teamMembers.map((member, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden">
              <div className="relative bg-gradient-to-br from-purple-50 to-purple-100/30 p-6 sm:p-8 flex justify-center items-center">
                <div className="w-2/3 aspect-[3/4] overflow-hidden rounded-lg shadow-md">
                  <img 
                    src={member.image} 
                    alt={member.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="p-4 sm:p-6">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-1">{member.name}</h3>
                <p className="text-sm text-gray-500 mb-2">{member.nameEn}</p>
                <p className="text-purple-600 font-semibold mb-2 sm:mb-3 text-sm sm:text-base">{member.position}</p>
                <p className="text-gray-600 text-xs sm:text-sm leading-relaxed text-left">{member.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
